import {
	Box,
	Button,
	Container,
	FormControl,
	FormControlLabel,
	FormLabel,
	Grid,
	MenuItem,
	Radio,
	RadioGroup,
	TextField,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Form from "../../../components/Form";
import MuiDatePicker from "../../../components/MuiDatePicker";
import { createPoll, updatePoll } from "../../../redux/actions/polls.action";
import { getAllStates, getAllConstituency, getAllConstituenciesMP } from "../../../redux/actions/pollBharat.action";
import { FormHelperText } from "@mui/material";
import dayjs from "dayjs";
import PollOptionsV2 from "./PollOptionsV2";
import { validateSlug } from "../../../services/poll";
import SunEditor from 'suneditor-react';
import 'suneditor/dist/css/suneditor.min.css';
import { font, fontSize, align, list, link, formatBlock } from "suneditor/src/plugins";
import { clearPollOptions } from "../../../redux/actions/pollOptions.action";
import PollOptionsV3 from "./PollOptionsV3";


const PollForm = ({
	openForm,
	setOpenForm,
	isEdit,
	pollDetails,
	setPollDetails,
	categories,
	durations,
	filePreview,
	setFilePreview,
	editDetails,
	setEditDetails,
	campaigns,
	clients,
	setClientId,
	adminRole,
}) => {


	const blogRef = useRef(null);
	const dispatch = useDispatch();
	const [activeError, setActiveError] = useState(false);
	const [optionError, setOptionError] = useState("");
	const [showIncomingCampaign, setShowIncomingCampaign] = useState(false);
	const [duration, setDuration] = useState("");
	const [viewBharatPollState, setViewBharatPollState] = useState(false);
	const [numOpts, setNumOpts] = useState(10);
	const [numOptsVal, setNumOptsVal] = useState(0);
	const totalBlogLength = 10000;

	useEffect(() => {
		if (!openForm) {
			setNumOpts(10)
			setActiveError(false);
			setViewBharatPollState(false);
		}
		if (isEdit) {
			setShowIncomingCampaign(true);
			setNumOpts(pollDetails?.options?.length)
		}
		if (!isEdit) {
			setNumOpts(2)
			setShowIncomingCampaign(false);
		}
		setDuration(pollDetails.duration_id);


		if (pollDetails?.client_id === process.env.REACT_APP_BHARATVOTECLIENTID && isEdit) {
			// console.log("bug", pollDetails);
			setViewBharatPollState(true);

			setPollDetails({ ...pollDetails, state: pollDetails?.pollBharat?.state?.name, constituency: pollDetails?.pollBharat?.constituency?.name, mp_name: pollDetails?.pollBharat?.party_mp?.mp_name })
			dispatch(getAllConstituency(pollDetails?.pollBharat?.constituency?.state_id));
			dispatch(getAllConstituenciesMP(pollDetails?.pollBharat?.constituency?.id));
		}
	}, [openForm]);


	//	//!	Poll Bharat...
	useEffect(() => {
		if (!viewBharatPollState) return
		dispatch(getAllStates());
	}, [viewBharatPollState])

	const { statesOfIndia, constituencies, constituenciesMp } = useSelector((state) => ({
		statesOfIndia: state.statesReducer,
		constituencies: state.constituencyReducer,
		constituenciesMp: state.constituenciesMpReducer,
	}));

	const [indianStates, setIndianState] = useState([]);
	const [indianStateConstituencies, setIndianStateConstituencies] = useState([]);
	const [indianStateConstituenciesMp, setIndianStateConstituenciesMp] = useState([]);
	useEffect(() => {
		if (statesOfIndia?.length > 0) return;
		setIndianState(statesOfIndia?.states);
	}, [statesOfIndia, indianStates]);

	useEffect(() => {
		if (indianStateConstituencies?.length > 0) return;
		setIndianStateConstituencies(constituencies?.constituencies);
	}, [constituencies]);

	useEffect(() => {
		if (indianStateConstituenciesMp?.length > 0) return;
		setIndianStateConstituenciesMp(constituenciesMp?.constituenciesMp);
	}, [constituenciesMp]);


	function checkOptionValidate(options) {
		// console.log("OPTIONS", options);
		// Check if total no. of options exist:
		if (!isEdit && !options) return "Options are required";
		let status = false;
		for (let i = 0; i < options?.length;) {
			if (!options[i].option) return `Option ${i + 1} is missing`;
			if (status) {
				// [SECOND STEP] Checking if another option doesn't have image
				if (options[i].image || options[i].option_image) return i++;
				return `Option ${i + 1} image is missing`;
			} else {
				if (options[i].image) {
					// [FIRST STEP] Checking if any option has an image:
					status = true;
					i = 0;	// Resetting to index 0, to check all options image from starting
				} else {
					i++;
				}
			}
		}

		return false;
	}

	const formValidate = async (pollDetails) => {
		if (
			!(!pollDetails.poll_name || pollDetails.poll_name === "") &&
			!(!pollDetails.category_id || pollDetails.category_id === "") &&
			!(!pollDetails.campaign) &&
			!(!pollDetails.start_date || pollDetails.start_date === "") &&
			!(!pollDetails.slug || pollDetails.slug === "") &&
			!(!pollDetails.question || pollDetails.question === "") &&
			!(!pollDetails.order || pollDetails.order === "")
		) {
			const isValidSlug = await validateSlug(pollDetails.slug, pollDetails.campaign?.campaign_id);
			if (!isValidSlug.success) return false;
			return true;
		} else {
			return false;
		}
	};

	// Remove it, if you want to get fired
	const render = {
		renderValue: () => pollDetails?.campaign?.id
	};

	const handleSubmit = async (e) => {
		e.preventDefault();

		if (pollDetails?.blog?.length > totalBlogLength) return;
		// const pollData = new FormData();
		const pollData = { options: new Array(numOpts) };
		// console.log("bug SUBMIT", pollDetails);
		if (!isEdit) {
			setActiveError(true);
			let alertdata = checkOptionValidate(pollDetails.options);
			if (alertdata) {
				setOptionError(alertdata);
				setTimeout(() => {
					setOptionError("");
				}, 5000);
				return;
			}

			const isFormValid = await formValidate(pollDetails);
			if (!isFormValid) {
				setOptionError("Slug already exist");
				setTimeout(() => {
					setOptionError("");
				}, 5000);

				return;
			}

			if (isFormValid) {
				for (let value in pollDetails) {
					if (value === "options") {
						pollDetails.options?.forEach((pair, index) => {
							// pollData.append(`options[${index}][option]`, pair.option);
							// pollData.append(`options[${index}][image]`, pair.image);
							let opt = {
								option: pair?.option,
								image: pair?.image,
								order: Number(pair?.order),
							};
							pollData.options[index] = opt
						});
					}
					if (value === "campaign") {
						// pollData.append(value, JSON.stringify(pollDetails[value]));
						pollData.campaign = { ...pollDetails[value] };
					}
					if (value === "blog" && pollDetails[value] === "<p><br></p>") {
						// pollData.append(value, "");
						pollData[value] = ""
					}
					if (value === "numOpts") {
						continue;
					}
					if (value !== "options" && value !== "campaign") {
						// pollData.append(value, pollDetails[value]);
						pollData[value] = pollDetails[value];
					}
					if (value === "order") {
						pollData.order = Number(pollDetails.order);
					}
				}
				dispatch(createPoll(pollData));
				dispatch(clearPollOptions());
				setOpenForm(false);
				setPollDetails({
					poll_name: "",
					question: "",
					duration_id: "1",
					start_date: "",
					options: [
						{ option: "", image: null, order: "" },
						{ option: "", image: null, order: "" },
					],
					slug: ""
				});
				setEditDetails({});
				setOptionError("");
				setActiveError(false);
			}
		} else {
			if (!editDetails) {
				setOpenForm(false);
				setPollDetails({});
				setEditDetails({});
				setOptionError("");
				setActiveError(false);
				setViewBharatPollState(false);
				return;
			}
			setActiveError(true);
			console.log("SUBMIT", pollDetails);
			// console.log("VALIDATION", editDetails);
			const isNotOptionValid = checkOptionValidate(editDetails.options);
			if (isNotOptionValid) {
				setOptionError(isNotOptionValid);
				setTimeout(() => {
					setOptionError("");
					setActiveError(false);
				}, 5000);
				return;
			}
			for (let value in editDetails) {
				if (value === "options") {
					editDetails.options?.forEach((pair, index) => {
						// pollData.append(`options[${index}][id]`, pair.id ? pair.id : "");
						// pollData.append(`options[${index}][option]`, pair.option);
						// pollData.append(`options[${index}][image]`, pair.image);
						let opt = {
							id: pair.id ? pair.id : "",
							option: pair.option,
							image: pair.image,
							order: Number(pair.order)
						}
						pollData.options[index] = opt
					});
				}
				if (value === "campaign") {
					// pollData.append(value, JSON.stringify(editDetails[value]));
					pollData.campaign = { ...editDetails[value] };
				}
				if (value === "numOpts") {
					continue;
				}
				if (value !== "options" && value !== "campaign") {
					// pollData.append(value, editDetails[value]);
					pollData[value] = editDetails[value];
				}
				if (value === "order") {
					pollData.order = Number(editDetails.order);
				}
			}

			// for (let data of pollData.entries()) {
			// 	// console.log("FORMDATA>>>>", data);
			// 	console.log("FORMDATA", data[0], data[1]);
			// }
			dispatch(updatePoll(pollDetails.id, pollData));
			dispatch(clearPollOptions());
			setOpenForm(false);
			setNumOpts(10);
			setPollDetails({});
			setEditDetails({});
			setOptionError("");
			setActiveError(false);
			setViewBharatPollState(false);
		}
	};

	const addOptionFields = () => {
		if (numOptsVal >= 10) {
			setNumOpts(numOptsVal);
		}
	}

	const handleInputChange = (e, campaign) => {
		const { name, value } = e.target;
		if (name === "numOpts") {
			setNumOptsVal(value);
		}
		if (!isEdit) {
			if (name === "duration_id") {
				// todo: delete all imgs from gcp
				// clear pollDetails.options
				const initialPollData = { ...pollDetails };
				initialPollData.options = [];
				setPollDetails(initialPollData);
				if (value == 1) {
					setNumOpts(2);
				} else {
					setNumOpts(10);
				}
				setDuration(value);
				if (!pollDetails.end_date) setPollDetails({ ...pollDetails, [name]: value, ["end_date"]: pollDetails.start_date });
				else setPollDetails({ ...pollDetails, [name]: value });
			} else {
				setPollDetails({ ...pollDetails, [name]: value });
			}
		} else {
			if (name === "campaign") {
				setPollDetails({
					...pollDetails,
					campaign_id: value.campaign_id,
					campaign_name: value.name,
				});
				setEditDetails({
					...editDetails,
					campaign_id: value.campaign_id,
					campaign_name: value.name,
				});
			}
			if (name === "duration_id") {
				if (value === "1") {
					const initialPollData = { ...pollDetails };
					const [option1, option2, ...other] = pollDetails.options;
					initialPollData.options = [
						{ ...option1 },
						{ ...option2 },
					];
					setPollDetails({ ...initialPollData, [name]: value, });
					setEditDetails({ ...editDetails, [name]: value, });
				}
				if (value === "2") {
					const initialPollData = { ...pollDetails };
					const [option1, option2, ...other] = pollDetails.options;
					if (other?.length) {
						initialPollData.options = pollDetails.options;
					} else {
						initialPollData.options = [
							{ ...option1 },
							{ ...option2 },
							{ option: "", image: null, order: "" },
							{ option: "", image: null, order: "" },
							{ option: "", image: null, order: "" },
							{ option: "", image: null, order: "" },
							{ option: "", image: null, order: "" },
							{ option: "", image: null, order: "" },
							{ option: "", image: null, order: "" },
							{ option: "", image: null, order: "" },
						];
					}
					setPollDetails({ ...initialPollData, [name]: value, });
					setEditDetails({ ...editDetails, [name]: value, });
				}
			}
			else {
				setPollDetails({ ...pollDetails, [name]: value });
				setEditDetails({ ...editDetails, [name]: value });
			}
		}
	};

	const handleClientChange = (e) => {
		const { name, value } = e.target;

		//!	Show [ State, Constituency & MP ] when select the Bharat Poll...
		if (e.target?.value === process.env.REACT_APP_BHARATVOTECLIENTID) {
			setViewBharatPollState(true);
		} else {
			setViewBharatPollState(false);
		}

		const client = clients.filter((client) => client.client_id === value);
		const key = "client_name";
		setPollDetails({ ...pollDetails, [name]: value, [key]: client[0].name });
		if (isEdit) setEditDetails({ ...editDetails, [name]: value, [key]: client[0].name });
		setClientId(value);
		setShowIncomingCampaign(false);
	};

	const handleBlogChange = (value) => {
		const key = "blog";
		setPollDetails(prev => ({ ...prev, [key]: value }));
		setEditDetails(prev => ({ ...prev, [key]: value }));
	}

	// //!	Handle Bharat Poll Change...
	const handleBharatPollInputChange = (e) => {
		const { name, value } = e.target;
		if (name === 'state') {
			setIndianStateConstituencies([]);
			setIndianStateConstituenciesMp([])
			const state = indianStates?.filter((e) => { return e.name === value })[0];
			dispatch(getAllConstituency(state.id));
			setPollDetails({ ...pollDetails, [name]: value, state_id: state.id });
		}
		if (name === 'constituency') {
			setIndianStateConstituenciesMp([])
			const constituency = indianStateConstituencies?.filter((e) => { return e.name === value })[0];
			dispatch(getAllConstituenciesMP(constituency.id));
			setPollDetails({ ...pollDetails, [name]: value, constituency_id: constituency.id });
		}
		if (name === 'mp_name') {
			const party_mp = indianStateConstituenciesMp.filter((e) => e.mp_name === value)[0];
			setPollDetails({ ...pollDetails, [name]: value, party_mp_id: party_mp.id });
		}

		if (isEdit) {
			if (name === 'state') {
				const state = indianStates.filter((e) => e.name === value)[0];
				setEditDetails({ ...editDetails, state_id: state.id });
			}
			if (name === 'constituency') {
				const constituency = indianStateConstituencies.filter((e) => e.name === value)[0];
				setEditDetails({ ...editDetails, constituency_id: constituency.id });
			}
			if (name === 'mp_name') {
				const party_mp = indianStateConstituenciesMp.filter((e) => e.mp_name === value)[0];
				setEditDetails({ ...editDetails, party_mp_id: party_mp.id });
			}
		}
	}

	return (
		<Form
			isEdit={isEdit}
			openForm={openForm}
			setOpenForm={setOpenForm}
			title={!isEdit ? "Create new poll" : "Update poll"}
			setDetails={setPollDetails}
			handleSubmit={handleSubmit}
			setEditDetails={setEditDetails}>
			<Container>
				<Grid container spacing={2} key='form' component='form'>
					<Grid item xs={6}>
						<TextField
							margin='normal'
							required
							fullWidth
							id='poll_name'
							label='Blog Title'
							name='poll_name'
							value={pollDetails?.poll_name}
							onChange={handleInputChange}
							autoFocus
							error={
								activeError &&
								(!pollDetails.poll_name || pollDetails.poll_name === "")
							}
							helperText={
								activeError &&
								(!pollDetails.poll_name || pollDetails.poll_name === "") &&
								"Poll name is required"
							}
						/>
						<label htmlFor="blog" style={{ color: "#555" }}>Blog</label>
						<SunEditor
							ref={blogRef}
							onChange={handleBlogChange}
							setContents={pollDetails.blog}
							setDefaultStyle="font-family: Inter; font-size: 16px;"
							setOptions={{
								buttonList: [
									["bold", "underline", "italic"],
									["link"],
									["font", "fontSize", "formatBlock"],
									["align", "list"],
									["fullScreen", "codeView"],
								],
								plugins: [
									font,
									fontSize,
									align,
									list,
									link,
									formatBlock,
								],
								font: [
									"Inter",
									"Arial",
									"Calibri",
									"Comic Sans",
									"Georgia",
									"Impact",
									"Tahoma",
									"Times New Roman",
								],
								pasteTagsBlacklist: 'meta|xml',
								attributesWhitelist: {
									all: 'href,target,src,alt,title,class,data-custom', 
								},
							}}
						/>
						<label
							htmlFor="blog"
							style={{ color: `${pollDetails.blog?.length > totalBlogLength ? "red" : "#333"}`, fontSize: "12px" }}
						>Characters left: {totalBlogLength - (pollDetails?.blog?.length || 0)}
						</label>
						{adminRole === parseInt(process.env.REACT_APP_ADMIN_ROLE_ID) && (
							<TextField
								select
								margin='normal'
								required
								fullWidth
								id='client'
								label='Client'
								name='client_id'
								value={pollDetails?.client_id}
								onChange={handleClientChange}
								error={
									activeError &&
									(!pollDetails.client_id || pollDetails.client_id === "")
								}
								helperText={
									activeError &&
									(!pollDetails.client_id || pollDetails.client_id === "") &&
									"Please select client of the poll"
								}>
								{clients?.map((option) => (
									<MenuItem key={option.name} value={option.client_id}>
										{option.name}
									</MenuItem>
								))}
							</TextField>
						)}
						<TextField
							select={!showIncomingCampaign}
							margin='normal'
							required
							fullWidth
							id='campaign'
							label='Campaign'
							name='campaign'
							onChange={handleInputChange}
							{...(showIncomingCampaign ? { value: pollDetails?.campaign?.name } : { selectProps: { render } })}
							error={activeError && !pollDetails.campaign}
							helperText={
								activeError &&
								(!pollDetails.campaign ||
									pollDetails.campaign?.campaign_id === "") &&
								"Please select campaign name"
							}>
							{campaigns?.map((option) => (
								<MenuItem key={option.name} value={option}>
									{option.name}
								</MenuItem>
							))}
						</TextField>
						<TextField
							select
							margin='normal'
							required
							fullWidth
							id='category'
							label='Category'
							name='category_id'
							value={editDetails?.category_id || pollDetails?.category?.id}
							onChange={handleInputChange}
							error={
								!isEdit ?
									activeError &&
									(!pollDetails.category_id || pollDetails.category_id === "")
									: activeError && !pollDetails.category
							}
							helperText={
								!isEdit ?
									activeError &&
									(!pollDetails.category || !pollDetails.category_id || pollDetails.category_id === "") &&
									"Please select a category for this poll"
									: activeError && !pollDetails.category && "Please select a category for this poll"
							}>
							{categories?.map((option) => (
								<MenuItem key={option.name} value={option.id}>
									{option.name !== "Other" ? option.name : "POTD"}
								</MenuItem>
							))}
						</TextField>
						<FormControl margin='normal' fullWidth required>
							<FormLabel id='duration_id'>Duration</FormLabel>
							<RadioGroup
								row
								aria-labelledby='duration_id'
								name='duration_id'
								value={pollDetails?.duration_id || 1}
								onChange={handleInputChange}>
								{durations?.map((option) => (
									<FormControlLabel
										key={option.id}
										value={option.id}
										control={<Radio />}
										label={option.duration}
									/>
								))}
								{
									duration === "2" && (<>
										<TextField
											label="Number of options (Min 10)"
											variant="filled"
											fullWidth
											sx={{ width: 1 / 3 }}
											name='numOpts'
											type="number"
											onChange={handleInputChange}
											inputProps={{
												min: 10,
												style: {
													paddingBottom: 0
												}
											}}
										/>
										<Button
											variant="contained"
											sx={{ margin: "auto 16px", textTransform: "capitalize" }}
											onClick={addOptionFields}
											disabled={numOptsVal < 10}
										>Set</Button>
									</>)
								}
							</RadioGroup>
							{activeError &&
								(!pollDetails.duration_id ||
									pollDetails.duration_id === "") && (
									<FormHelperText sx={{ color: "red" }}>
										Please select the duration of this poll.
									</FormHelperText>
								)}
						</FormControl>
						<MuiDatePicker
							poll={pollDetails}
							setPoll={setPollDetails}
							isEdit={isEdit}
							setEditDetails={setEditDetails}
							editDetails={editDetails}
							value={dayjs(pollDetails?.start_date)}
							name='start_date'
							label='Start Date'
						/>
						{activeError &&
							(!pollDetails.start_date || pollDetails.start_date === "") && (
								<FormHelperText sx={{ color: "red" }}>
									Please select start date.
								</FormHelperText>
							)}

					
						{
							<MuiDatePicker
								poll={pollDetails}
								setPoll={setPollDetails}
								isEdit={isEdit}
								setEditDetails={setEditDetails}
								editDetails={editDetails}
								value={dayjs(pollDetails?.end_date)}
								name='end_date'
								label='End Date'
							/>
						}
					</Grid>
					<Grid item xs={6}>
						<Grid container spacing={2} key='form' component='form'>
							<Grid item xs={10}>
								<TextField
									margin='normal'
									required
									fullWidth
									id='question'
									label='Question'
									name='question'
									value={pollDetails?.question}
									onChange={handleInputChange}
									autoComplete='email'
									error={
										activeError &&
										(!pollDetails.question || pollDetails.question === "")
									}
									helperText={
										activeError &&
										(!pollDetails.question || pollDetails.question === "") &&
										"Question is required"
									}
								/>
							</Grid>
							<Grid item xs={2}>
								<TextField
									margin='normal'
									required
									fullWidth
									id='order'
									label='Order'
									name='order'
									type="number"
									value={pollDetails?.order}
									onChange={handleInputChange}
									autoComplete='order'
									error={
										activeError &&
										(!pollDetails.order || pollDetails.order === "")
									}
									helperText={
										activeError &&
										(!pollDetails.order || pollDetails.order === "") &&
										"Order is required"
									}
								/>
							</Grid>
						</Grid>
						{activeError && optionError && (
							<FormHelperText sx={{ color: "red" }}>
								{optionError}
							</FormHelperText>
						)}
						<TextField
							margin='normal'
							required
							fullWidth
							id='slug'
							label='Slug'
							name='slug'
							value={pollDetails?.slug}
							onChange={handleInputChange}
							error={
								activeError &&
								(!pollDetails.slug || pollDetails.slug === "")
							}
							helperText={
								activeError &&
								(!pollDetails.slug || pollDetails.slug === "") &&
								"Slug is required"
							}
						/>
						<p>{numOpts} Options</p>
						<PollOptionsV3
							numOpts={numOpts}
							pollDetails={pollDetails}
							setPollDetails={setPollDetails}
							editDetails={editDetails}
							setEditDetails={setEditDetails}
							isEdit={isEdit}
							filePreview={filePreview}
							setFilePreview={setFilePreview}
							duration={duration}
						/>


						{/* ! For [State,Constituation,MP's]  */}
						<Grid item xs={11} style={{ display: `${viewBharatPollState ? "block" : "none"}` }}>
							<TextField
								select={isEdit ? showIncomingCampaign : !showIncomingCampaign}
								margin='normal'
								fullWidth
								id='state'
								label='State'
								name='state'
								value={pollDetails?.state}
								onChange={handleBharatPollInputChange}
								setEditDetails={setEditDetails}
								editDetails={editDetails}
								error={
									activeError &&
									(!pollDetails.state || pollDetails.state === "")
								}
								helperText={
									activeError &&
									(!pollDetails.state || pollDetails.state === "") &&
									"Please select state of the poll"
								}>
								{indianStates && indianStates.map((option, index) => (
									<MenuItem key={option.id} value={option.name}>
										{option.name}
									</MenuItem>
								))}
							</TextField>
							<TextField
								select={isEdit ? showIncomingCampaign : !showIncomingCampaign}
								margin='normal'
								fullWidth
								id='constituency'
								label='Constituency'
								name='constituency'
								value={pollDetails?.constituency}
								onChange={handleBharatPollInputChange}
								setEditDetails={setEditDetails}
								editDetails={editDetails}
								error={
									activeError &&
									(!pollDetails.constituency || pollDetails.constituency === "")
								}
								helperText={
									activeError &&
									(!pollDetails.constituency || pollDetails.constituency === "") &&
									"Please select constituency of the poll"
								}>
								{indianStateConstituencies && indianStateConstituencies.map((option, index) => (
									<MenuItem key={option.id} value={option.name}>
										{option.name}
									</MenuItem>
								))}
							</TextField>
							<TextField
								select={isEdit ? showIncomingCampaign : !showIncomingCampaign}
								margin='normal'
								fullWidth
								id='mp_name'
								label='MP'
								name='mp_name'
								value={pollDetails?.mp_name}
								onChange={handleBharatPollInputChange}
								setEditDetails={setEditDetails}
								editDetails={editDetails}
								error={
									activeError &&
									(!pollDetails.mp_name || pollDetails.mp_name === "")
								}
								helperText={
									activeError &&
									(!pollDetails.mp_name || pollDetails.mp_name === "") &&
									"Please select MP name of the poll"
								}>
								{indianStateConstituenciesMp && indianStateConstituenciesMp.map((option, index) => (
									<MenuItem key={option.id} value={option.mp_name}>
										{option.mp_name}
									</MenuItem>
								))}
							</TextField>
						</Grid>
					</Grid>
				</Grid>
			</Container>
		</Form>
	);
};

export default PollForm;
